export default "__VITE_ASSET__D1li4$LV__"